import React from "react";
import { NavLink, Link} from 'react-router-dom';

export default (props) => {
    return (
        <ul className="menu-content-nav">
            {/* <NavLink to="/makeorder"> Создать заказ</NavLink>  */}
            <Link className="big-button without-shadow" style={{maxWidth: '200px', height:'44px'}} to="/makeorder">
                <button className="btn-buy" style={{padding:0, height:'44px'}}>
                    Создать заказ
                </button>
            </Link>

            <NavLink to="/orders/customer/all"> Все</NavLink>
            <NavLink exact to="/orders" className={(!props.id) ? 'active' : ''}> Мои (все)</NavLink>
            <NavLink to="/orders/customer/draft"> Черновики</NavLink>
            <NavLink to="/orders/customer/place"> Поиск исполнителя</NavLink>
            <NavLink to="/orders/customer/wait_contractor"> На исполнении</NavLink>
            <NavLink to="/orders/customer/wait_me"> На приемке</NavLink>
            <NavLink to="/orders/customer/finish"> Выполненные</NavLink>
            <NavLink to="/orders/customer/complaint"> Претензия</NavLink>
        </ul>
    )
}


// WEBPACK FOOTER //
// ./src/components/Orders/CustomerNav.js